import { inforOrangeIcon } from '@/shared/ui/assets';
import { t } from 'ttag';
import type { WarningMessageProps } from './warningMessage.types';

const WarningMessage = ({
  isIcorDevice,
  isBiofluxDirect,
  isMissingEmailWhenDeviceBiotresAndOutsideUS,
  shouldShowStudyTypeWarningText,
}: WarningMessageProps) => {
  if (isIcorDevice) {
    return (
      <div className="biodirect-warning-msg">
        <img src={inforOrangeIcon} alt="inforOrangeIcon" />
        <span>
          {t`Please enter the correct iCOR device ID. This is required to upload data after the study ends.`}
        </span>
      </div>
    );
  }

  if (isBiofluxDirect) {
    return (
      <div className="biodirect-warning-msg">
        <img src={inforOrangeIcon} alt="inforOrangeIcon" />
        <span>
          {t`Please note that Biodirect requires the patient's email for shipping purposes.`}
        </span>
      </div>
    );
  }

  if (isMissingEmailWhenDeviceBiotresAndOutsideUS) {
    return (
      <div className="biodirect-warning-msg">
        <img src={inforOrangeIcon} alt="inforOrangeIcon" />
        <span>
          {t`Patients located outside the United States and Canada must provide an email address to receive a Biocore study reference code.`}
        </span>
      </div>
    );
  }

  if (shouldShowStudyTypeWarningText) {
    return (
      <div className="warning-study-type">
        <img src={inforOrangeIcon} alt="inforOrangeIcon" />
        <span>{t`Please confirm reimbursement if Blue Cross Blue Shield.`}</span>
      </div>
    );
  }

  return null;
};

export default WarningMessage;
